import React, { useContext, useEffect, useState } from 'react'
import styled from 'styled-components'
import Pagination from '../Pagination'
import PaginationTinyOptions from '../PaginationTinyOptions'
import { RequestsContext } from '../../context/requests'

const Box = styled.div`
    display: flex;

`
const BoxOptions = styled.div`
    display:flex;
    align-items: center;
`
const CardWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 20rem;
    padding-right: 2rem;

    position: fixed;
    bottom:0;
    width: 100%;
    height: 80px;
    bottom: 0;
    box-shadow:  0 0 5px #3d3b3ba6;
    background-color: white;
`
const CardText = styled.div`
    margin-right: 1.3rem;

    .textPrimary{
        font-family: "Poppins";
        font-weight: 600;
        color: black;
    }

    p{
        font-size:1rem;
        font-family: "Poppins";
        font-weight: 600;
        height: 5px;
    }
`
const Row = styled.div`
    display: flex;
    align-items: center;

    svg{
        cursor: pointer;
    }


`
const Button = styled.button`
    font-family: "Poppins";
    font-weight: 600;
    background-color: white;
    width: auto;
    height: 29px;
    font-size: 0.9rem;
    border: 1px solid black;
    width: 119px;
    border-radius: 15px;
`

const Circle = styled.div`
    font-family: "Poppins";
    font-weight: 600;
    font-size: 1.5rem;
`


const FooterTinyOptions = ({ quantity, value, animation, onClick }) => {
    const { requests, selectItems } = useContext(RequestsContext)

    const totalValue = requests.reduce((acc, item) => {
        const price = Number(item.price) || 0;
        const quantity = Number(item.quantity) || 0;
        const delivery = Number(item.coust_delivery) || 0;

        return acc + price * quantity + delivery;
    }, 0);

    const totalSelectValue = selectItems.reduce((acc, item) => {
        const price = Number(item.price) || 0;
        const quantity = Number(item.quantity) || 0;
        const delivery = Number(item.coust_delivery) || 0;

        return acc + price * quantity + delivery;
    }, 0);



    return (

        <CardWrapper className={animation ? "animate__animated animate__fadeInUp " : ""}>
            <BoxOptions>
                <PaginationTinyOptions />
                <Button onClick={onClick}>mais ações</Button>
            </BoxOptions>
            <Box>
                <CardText>
                    <p className='textPrimary animate__animated  animate__bounceIn' style={{color:"#006fff"}}>{Number(totalSelectValue).toLocaleString("pt-BR",{minimumFractionDigits:2})}</p>
                    <p>Selecionados (R$)</p>
                </CardText>
                <CardText>
                    <p className='textPrimary'>{requests.length}</p>
                    <p>quantidade</p>
                </CardText>
                <CardText>
                    <Row>
                        <div>
                            <p className='textPrimary'>R$ {Number(totalValue).toLocaleString("pt-BR", { minimumFractionDigits: 2 })}</p>
                            <p>valor total</p>
                        </div>
                        <a href="#top">

                            <svg width="22" height="28" viewBox="0 0 22 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6.50562 10.8147C6.29468 10.6036 6.29468 10.4043 6.50562 10.2167L10.5837 6.13631C10.7712 5.92526 10.9587 5.92526 11.1462 6.13631L15.2244 10.2167C15.4353 10.4043 15.4353 10.6036 15.2244 10.8147L14.9783 11.0609C14.7908 11.2719 14.5916 11.2719 14.3806 11.0609L11.4626 8.10614V21.3322C11.4626 21.6136 11.322 21.7543 11.0408 21.7543H10.6892C10.408 21.7543 10.2673 21.6136 10.2673 21.3322V8.10614L7.34937 11.0609C7.25562 11.1547 7.15015 11.2016 7.03296 11.2016C6.91577 11.2016 6.82202 11.1547 6.75171 11.0609L6.50562 10.8147Z" fill="#A1A1A1" />
                            </svg>
                        </a>
                    </Row>

                </CardText>
            </Box>

        </CardWrapper>

    )
}

export default FooterTinyOptions